import $ from 'jquery';
export function formErrorClear() {
    const input = $('input');
    input.keypress(function () {
        $('fieldset.error').removeClass('error');
        $('span.error-text').remove();
    });
}